import v8n from 'v8n';
import validator from 'validator';

export const composeValidators = validators => {
  return value => {
    // eslint-disable-next-line no-unused-vars
    for (let validate of validators) {
      const result = validate(value);
      if (result) return result;
    }

    return undefined;
  };
};

export const email = value => {
  let error;
  if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = 'Invalid email address';
  }
  return error;
};

export const phone = value => {
  let error;
  if (value && !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/i.test(value)) {
    error = 'Invalid phone number';
  }
  return error;
};

export const required = value => {
  let error;
  if (!value) {
    error = 'Required';
  }
  return error;
};

export const date = value => {
  let error;
  if (!value) {
    error = 'Invalid date';
  }

  return error;
};

export const alpha = value => {
  let error;
  if (!validator.isAlpha(value)) {
    error = 'Please, provide valid alphabetic value for this field';
  }

  return error;
};

/*
  Input values filter. Restrict certain keyboard input
 */

export const positiveNumber = value =>
  v8n().number(false).positive().test(value);

export const positiveInteger = value => v8n().integer().positive().test(value);
